<template>
  <div class="scene-i" @click="click" :star="star" :selected="!edit && scene.active" :checked="edit && isChecked===''">
    <div v-if="edit">
      <el-radio v-model="isChecked" label="" :disabled="disabled" @change="change"></el-radio>
    </div>
    <img :src="icon" style="width: 55px"/>
    <div class="content">
      <div class="title" v-text="scene.name">--</div>
      <div class="remark auto-hide" :title="scene.remark" v-text="scene.remark">--</div>
    </div>
    <div class="collection" v-if="star&&!edit">
      <img :src="starIcon" style="width:28px" @click.stop="collection"/>
    </div>
  </div>
</template>

<script>
/*
* 为了后续的扩展，支持多种方式加载场景图标，主要为以下几种
* 1、http远程加载
* 2、从本地项目加载（进行映射关系）
* 3、icon-font字体加载
 */
import resource from '../model/resource'
import scene from '../model/scene'
import { Message } from 'element-ui'

export default {
  name: 'Scene',
  props: {
    scene: {
      type: Object
    },
    edit: {
      type: Boolean,
      default: false
    },
    star: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return { isChecked: false }
  },
  computed: {
    isCollection () {
      return this.$store.state.collection.scenes.filter(s => s.id === this.scene.id).length
    },
    icon () {
      if (this.edit) {
        return resource.getResource(this.scene.icon)
      }
      if (this.scene.active) {
        return resource.getActiveResource(this.scene.icon)
      } else {
        return resource.getResource(this.scene.icon)
      }
    },
    starIcon () {
      if (this.isCollection) {
        return require('../assets/images/scene/ysc.png')
      } else {
        return require('../assets/images/scene/sc.png')
      }
    },
    disabled () {
      if (this.edit) {
        if (this.$parent.feature && (this.$parent.feature.command === 'delete' || this.$parent.feature.command === 'modify')) {
          if (this.scene.type === 1) {
            return true
          }
        }
      }
      return false
    }
  },
  created () {
    this.$hub.$on('checkedScene', id => {
      if (this.scene.id === id) {
        this.isChecked = ''
      } else {
        this.isChecked = false
      }
    })
  },
  methods: {
    change () {
      this.isChecked !== false && this.$hub.$emit('checkScene', { isChecked: true, id: this.scene.id })
    },
    collection () {
      // 进行相应的收藏或取消收藏操作
      if (this.isCollection) {
        this.$store.commit('UN_COLLECT', { type: 'scene', data: { id: this.scene.id, remark: this.scene.name } })
      } else {
        this.$store.commit('COLLECT', { type: 'scene', data: { id: this.scene.id, remark: this.scene.name } })
      }
    },
    async click () {
      if (this.edit) {
        return
      }
      // 开始激活场景，激活完成后，标记场景状态
      try {
        await scene.active(this.scene.id)
        // 处理状态变化
        this.$store.commit('ACTIVE_SCENE', this.scene.id)
      } catch (e) {
        Message.error(e.message)
      }
    }
  },
  mounted () {
    this.$emit('change', 'sceneHtml')
  }
}
</script>

<style scoped lang="less">
@import "../assets/less/base";

.scene-main[checked] {
  border: 1px solid rgba(58, 212, 116, 1);
}

.scene-i[selected] {
  background: linear-gradient(135deg, rgba(42, 212, 115, 1), rgba(87, 207, 121, 1));
  > div {
    .title {
      color: white;
    }
    .remark {
      color: white;
    }
  }
}

.scene-i[star] {
  padding: 20px;
  height: 100px;
}

.scene-i {
  cursor: pointer;
  /*display: inline-block;*/
  padding: 12px 20px;
  min-width: 230px;
  width: 32%;
  height: 84px;
  background: #ffffff;
  border-radius: 4px;
  display: flex;
  box-shadow: 0px 3px 17px 2px rgba(219, 219, 219, 0.3);
  align-items: center;
  .content {
    margin-left: 20px;
    flex: 1;
    width: 0;
    /*width: 150px;*/
    max-width: 70%;
    .title {
      font-size: 19px;
      font-weight: 600;
      color: rgba(34, 34, 34, 1);
    }
    .remark {
      width: 100%;
      max-width: 100%;
      font-size: 12px;
      font-weight: 400;
      color: rgba(89, 89, 89, 1);
    }
  }

  .collection {
    width: 30px;
    img {
      cursor: pointer;
    }
  }
}
</style>
